export default "__VITE_ASSET__Bxr0SLqc__"